import { Injectable } from '@angular/core';

type PluginInitializer = () => void;

@Injectable({ providedIn: 'root' })
export class PluginRegistryService {
  private _plugins: PluginInitializer[] = [];

  registerPlugin(init: PluginInitializer) {
    this._plugins.push(init);
  }

  runAll() {
    this._plugins.forEach((init) => {
      init();
    });
  }
}
